<template lang="pug">
#measurepop(v-show='sectionBoolean')
  ul
    li.item(v-for='(item,index) in sectionList' :key='index' :class="{'isActive':item.isActive}" @click='sectionFunc(item,index)')
      van-image(width='25' height='25' :src='item.icon' v-if='!item.isActive')
      van-image(width='25' height='25' :src='item.icons' v-else)
      span {{item.name}}
      van-image.right(v-if='item.isActive' :src='hookImg')
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data () {
    return {
      sectionBoolean: true,
      sectionList: [
        { name: "X轴剖切", icon: require("./../../images/modelImage/X.png"), icons: require("./../../images/modelImage/XS.png"), query: "x", isActive: false },
        { name: "Y轴剖切", icon: require("./../../images/modelImage/Y.png"), icons: require("./../../images/modelImage/YS.png"), query: "y", isActive: false },
        { name: "Z轴剖切", icon: require("./../../images/modelImage/Z.png"), icons: require("./../../images/modelImage/ZS.png"), query: "z", isActive: false },
        { name: "盒子剖切", icon: require("./../../images/modelImage/box.png"), icons: require("./../../images/modelImage/boxS.png"), query: "box", isActive: false },
        { name: "截取面剖切", icon: require("./../../images/modelImage/art.png"), icons: require("./../../images/modelImage/arts.png"), query: "art", isActive: false }
        // { name: "关闭剖切", icon: require("./../../images/modelImage/clear.png"),icons: require("./../../images/modelImage/clears.png"), query: "clear",isActive:false},
      ],
      hookImg: require("./../../images/hook.png")
    };
  },
  methods: {
    sectionFunc(item, index) {
      this.sectionList.forEach(ele => {
        if (ele.query == item.query) {
          item.isActive = !item.isActive;
        } else {
          ele.isActive = false;
        }
      });
      this.sectionBoolean = false;
      mongeApiMlib.section3D(item.query, true, true, true);
    }
  }
};
</script>

<style lang="scss" scoped>
#measurepop{
  position: fixed;
  bottom: 70px;
  left: 12px;
  width: calc(100% - 24px);
  height: 150px;
  max-height: calc(100% - 210px);
  z-index: 4;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #FFFFFF;
  border-radius: 10px;
  ul{
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 10px 0;
    li{
      height: 44px;
      padding: 0 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      span{
        margin-left: 7px;
        font-size: 16px;
        color: #2C303B;
      }
      .van-image{
        width: 25px;
        height: 25px;
      }
    }
    .isActive{
      background: rgba(56, 115, 254, 0.13);
      span{
        color: var(--theme-color);
      }
    }
    span{
      color: #dddddd;
    }
    .right{
      margin-left: auto;
    }
  }
  // ul::-webkit-scrollbar{width: 0 !important;}
  // ul{-ms-overflow-style: none;}
  // ul{overflow: -moz-scrollbars-none;}
}
</style>
